import MeetTheTeam from './MeetTheTeam';

export default MeetTheTeam;